<template>
  <div class="messageDetail">
    <div class="top-container">
      <div class="top">
        <img :src="back" alt="" @click="goBack">
        <div class="title">{{ $t('lang.message.MessageDetail') }}</div>
      </div>
    </div>
    <div class="detail">
      <!--      <div class="title">{{detail.name || 'qwerty'}}</div>-->
      <div class="subject">{{ welcomeMessage(detail.Title) }}</div>
      <div class="body" @click="htmlOutClick" v-html="(detail.Title === 'Processing Review Notice' || detail.Title==='Deposit Processing Review Notice' || detail.Title==='Withdrawal Processing Review Notice')?proofFormayText(detail.Content):formatText(detail.Content)"/>
      <div class="cashBonuses">
        <div class="cashBonusItem"
             v-for="(item, index) in cashBonusList"
             :key="index"
             >
          <div class="bonus">
            <img :src="bonus" alt=""/>
          </div>
          <div class="amount" style="margin-top: 8vw">
            <p>{{ $t('lang.account.bonus') }}</p>
            <p>{{ item.Amount }}</p>
          </div>
        </div>
      </div>
      <div class="cashBonuses" v-if="depositDiscountGift">
        <div class="cashBonusItem">
          <img :src="discount" alt="" class="discount"/>
          <div class="amount">
            <p>{{ $t('lang.message.bonusRate') + depositDiscountGift.Rate + '%' }}</p>
            <p>{{ $t('lang.message.maxReward') + depositDiscountGift.MaxAmount }}</p>
            <p>{{ $t('lang.message.deadline') + depositDiscountGift.DueTime }}</p>
          </div>
        </div>
      </div>

      <div class="end">
        <div>PGEbet</div>
        <div>{{ formatTime(detail.CreateTime) }}</div>
      </div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
      <div class="claim-btn-proof" v-if="profBtnShow && (detail.Title === 'Processing Review Notice' || detail.Title==='Deposit Processing Review Notice' || detail.Title==='Withdrawal Processing Review Notice')" @click="goProofDetail()">
        {{ $t('lang.account.details') }}
      </div>
      <div class="claim-btn" v-if="haveButton&&buttonStatus===true" @click="claimCashBonus">
        {{ $t('lang.account.claim') }}
      </div>
      <div class="claim-btn" v-if="haveButton&&buttonStatus===false" @click="claimCashBonus"
           style="filter: grayscale(100%);color: grey">
        {{ $t('lang.bonus.claimed') }}
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'
import cash from '@/assets/images/innerMessage/cash.jpg'
import bonus from '@/assets/images/innerMessage/bonus.svg'
import discount from '@/assets/images/innerMessage/discount.svg'
import request2 from '@/service2'
import back from '@/assets/images/common/back.svg'
import {Toast} from 'mint-ui'
import {fetchBalance} from '@/utils'

export default {
  name: 'messageDetail',
  props: ['detail', 'closeDetail'],
  data () {
    return {
      logo,
      cash,
      back,
      bonus,
      discount,
      fetchBalance,
      cashBonusList: [],
      depositDiscountGift: null,
      hasClaimed: false,
      haveButton: false,
      buttonStatus: null,
      proofParams: {},
      profBtnShow: false
    }
  },
  components: {},
  mounted () {
    let resultInfo = JSON.parse(sessionStorage.getItem('resultInfo'))
    if (resultInfo) {
      this.profBtnShow = false
    } else {
      this.profBtnShow = true
    }
    this.fetchCashBonus()
  },
  methods: {
    htmlOutClick (event) {
      if (event.target.tagName === 'A' && event.target.closest('.out')) {
        event.preventDefault()
        window.open(event.target.href)
      }
    },
    formatText (text) {
      text = this.welcomeMessage(text)
      text = text.replace(/\n/g, '<br>')
      text = text.split('<del>').join('<div class="out">').split('</del>').join('</div>')
      return text
    },
    proofFormayText (text) {
      console.log('jjjjjjjj')
      // 替换换行符和格式化文本
      text = text.replace(/\n/g, '<br>')
      text = text.split('<del>').join('<div class="out">').split('</del>').join('</div>')

      // 正则表达式匹配 a 标签的 href 属性
      const regex = /<a\s+href="([^"]+)">/i
      const match = text.match(regex)
      if (match && match[1]) {
        const href = match[1]
        // 提取查询参数
        const queryParams = href.split('?')[1]
        const params = queryParams.split('&amp;').reduce((acc, param) => {
          const [key, value] = param.split('=')
          acc[key] = decodeURIComponent(value)
          return acc
        }, {})
        // 提取 ticketId 和 ticketType
        const TicketId = params['TicketId'] || null
        const TicketType = params['TicketType'] || null

        // 构建返回的参数对象
        let paramsResult = {
          path: href.split('?')[0],
          TicketId: TicketId,
          TicketType: TicketType
        }
        this.proofParams = paramsResult
        console.log(paramsResult)
        // 移除文本中的 a 标签
        text = text.replace(new RegExp(`<a href="${href}">`, 'gi'), '').replace(/<\/a>/gi, '')
      }
      return text
    },
    welcomeMessage (text) {
      if (text.toLowerCase().indexOf('lang.welcome.title') > -1) {
        text = text.replace('$t(\'lang.welcome.title\')', this.$t('lang.welcome.title'))
      } else if (text.toLowerCase().indexOf('lang.welcome.message') > -1) {
        text = text.replace('$t(\'lang.welcome.message\')', this.$t('lang.welcome.message'))
      }
      return text
    },
    fetchCashBonus () {
      const url = '/innovation/newmessage/personalcashbonus'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        messageId: this.detail.Id
      }
      request2('post', url, data).then(res => {
        if (res) {
          if (res.CashBonuses) {
            this.cashBonusList = res.CashBonuses
          }
          this.depositDiscountGift = res.DepositDiscountGift
          if (this.depositDiscountGift) {
            this.depositDiscountGift.DueTime = this.formatTime(this.depositDiscountGift.DueTime)
          }
          this.haveButton = res.HaveButton
          this.buttonStatus = res.ButtonStatus
        }
      })
    },
    formatTime (dateTime) {
      let parts = dateTime.split('T')
      let dateParts = parts[0].split('-')
      let year = dateParts[0]
      let month = dateParts[1]
      let day = dateParts[2]
      let time = parts[1].substring(0, 5)
      return `${day}/${month}/${year} ${time}`
    },
    goBack () {
      if (this.cashBonusList && this.cashBonusList.length === 0) {
        this.detail.IsRead = true // 2024-02-02 YTW
      } else if (this.cashBonusList && this.cashBonusList[0].IsClaimed) {
        this.detail.IsRead = true
      }
      this.closeDetail()
    },
    goProofDetail () {
      sessionStorage.setItem('DetailShowType', 2)
      sessionStorage.setItem('TransactionData', JSON.stringify(this.proofParams))
      this.$router.push(this.proofParams.path)
    },
    claimCashBonus () {
      if (this.buttonStatus === false) {
        Toast(this.$t('lang.message.cannotClaimed'))
        return
      }
      var cnt = ''
      for (let i = 0; i < this.cashBonusList.length; i++) {
        const item = this.cashBonusList[i]
        if (i === 0) {
          cnt += ' ' + this.$t('lang.account.currencyType') + item.Amount + ' ' + this.$t('lang.message.claimCash') + ' '
        } else {
          cnt += '& ' + this.$t('lang.account.currencyType') + item.Amount + ' ' + this.$t('lang.message.claimCash')
        }
        item.IsClaimed = true
      }
      const url = '/innovation/newmessage/ClaimCashBonus'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        messageId: this.detail.Id
      }
      request2('post', url, data).then(res => {
        if (res) {
          this.fetchBalance()
          this.buttonStatus = false
        }
      })
      let msg = ''
      if (cnt && this.depositDiscountGift === null) {
        msg = this.$t('lang.message.claimSuccess') + cnt
      } else if (cnt && this.depositDiscountGift !== null) {
        msg = this.$t('lang.message.claimSuccess') + cnt + '& ' + this.$t('lang.account.wheel_deposit') + ' ' + this.depositDiscountGift.Rate + '% *1'
      } else if (!cnt && this.depositDiscountGift !== null) {
        msg = this.$t('lang.message.claimSuccess') + ' ' + this.$t('lang.account.wheel_deposit') + ' ' + this.depositDiscountGift.Rate + '% *1'
      }
      if (msg) {
        Toast(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.messageDetail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #161616;
  display: flex;
  flex-direction: column;

  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 93vw;
    margin: 0 auto;

    .top {
      display: flex;
      align-items: center;
      height: 15vw;

      .title {
        margin-left: 5vw;
        color: #F6D9AA;
        font-size: 5.277vw;
        font-weight: 700;
      }

      img {
        width: 8vw;
      }
    }
  }

  .detail {
    padding: 0 4.2vw 5.555vw;
    flex: 1;
    overflow-y: scroll;
    .subject {
      margin-top: 5.555vw;
      font-size: 6.388vw;
      font-weight: 700;
      text-align: left;
      color: #F6D9AA;
      margin-bottom: 2.5vw;
    }

    .body, .end {
      font-size: 3.888vw;
      line-height: calc(3.888vw + 2px);
      color: #C4C4C4;
      font-weight: 400;
      text-align: left;
      margin: 5vw 0 2.5vw 0;
    }

    .bottomLogo {
      text-align: right;

      img {
        width: 40px;
      }
    }

    .claim-btn {
      position: relative;
      top: 5vw;
      left: 50%;
      transform: translate(-50%);
      width: 90.2vw;
      height: 12.222vw;
      line-height: 12.222vw;
      font-size: 5.833vw;
      text-align: center;
      background-color: #F6D9AA;
      color: #000D2E;
      border-radius: 0.833vw;
      margin-bottom: 15vw;
    }
    .claim-btn-proof{
      position: relative;
      top: 50vw;
      left: 50%;
      transform: translate(-50%);
      width: 90.2vw;
      height: 11.11vw;
      line-height: 11.11vw;
      font-size: 4.166vw;
      text-align: center;
      background-color: #F6D9AA;
      color: #000D2E;
      border-radius: 0.833vw;
      margin-bottom: 15vw;
    }
  }

  .cashBonuses {
    display: flex;
    justify-content: flex-start;
    .cashBonusItem {
      position: relative;
      width: 23.333vw;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .bonus {
        margin: 1vw 2.8vw 0 -4vw;
        width: 15.666vw;

        img {
          width: 19.722vw;
        }
      }

      .discount {
        margin-top: 1vw;
        width: 12.5vw;
        margin-right: 2vw;
      }

      .amount {
        margin-top: 2.8vw;
        margin-left: 3.5vw;
        font-size: 3.218vw;
        font-weight: 400;
        text-align: left;
        color: #E4D9AA;
        width: max-content;
        white-space: nowrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Message/Children/messageDetail.vue